import GUI from 'lil-gui';
import type { DebugTuning } from '../game/tuning';

export class DebugTools {
  private gui: GUI | null = null;

  constructor(tuning: DebugTuning, onChange: () => void) {
    const enabled = new URLSearchParams(window.location.search).has('debug');
    if (!enabled) return;

    this.gui = new GUI({ title: 'NEON DRIFT tuning' });
    this.gui.add(tuning, 'exposure', 0.6, 1.8, 0.01).onChange(onChange);
    this.gui.add(tuning, 'bloom', 0, 2, 0.05).onChange(onChange);
    this.gui.add(tuning, 'fov', 34, 60, 1).onChange(onChange);
    this.gui.add(tuning, 'cameraLag', 0.02, 0.5, 0.01);
    this.gui.add(tuning, 'maxDpr', 1, 2, 0.25).onChange(onChange);
  }

  setHidden(hidden: boolean): void {
    if (!this.gui) return;
    if (hidden) this.gui.hide();
    else this.gui.show();
  }

  dispose(): void {
    this.gui?.destroy();
    this.gui = null;
  }
}
